import { Modal, Input, List, Button, message } from "antd"
import React, { useState } from "react"
import {Project} from "../../../types/Project";
import {useAppSelector} from "../../../hooks";
import {selectColleagues} from "../cohortBuilderSlice";
import {UserDetails} from "../../../actions/api";
import buttonStyles from "../../../components/common/styled/Buttons.module.scss";
import {apiShareProject} from "../cohortBuilderApi";
import styles from './ShareProject.module.scss';
import {UserIcon} from "./UserIcon";
import {UsersIcon} from "./UsersIcon";
import {getName} from "../../../util/user";

const ColleagueListItem: React.FC<{projectId: number, colleague: UserDetails}> = ({projectId, colleague}) => {
    const [shared, setShared] = useState(false)
    const [loading, setLoading] = useState(false)

    return <div className={styles['colleague-list-item']}>
        <UserIcon className={styles['colleague-icon']}/>
        <span className={styles['colleague-name']}>{getName(colleague)}</span>
        <Button
            loading={loading}
            type="primary"
            className={`${styles['share-button']} ${shared ? buttonStyles['greenPrimary'] : buttonStyles['primary']}`}
            onClick={() => {
                setLoading(true)
                apiShareProject(projectId, colleague.username)
                    .then(() => {
                        setShared(true)
                    })
                    .catch(() => {
                        message.error('An error occurred, project not shared')
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            }}
        >
            {shared ? "Shared" : "Share"}
        </Button>
    </div>
}

export type ShareProjectProps = {
    open: boolean,
    setOpen: (isOpen: boolean) => void
    project: Project
}

export const ShareProject = ({project, open, setOpen}: ShareProjectProps) => {
    const colleagues = useAppSelector(selectColleagues)
    const [filterText, setFilterText] = useState<string>('')

    const displayColleagues = (colleagues ?? []).filter(colleague => {
        return getName(colleague).toUpperCase().includes(filterText.toUpperCase())
    }).sort((a, b) => getName(a).localeCompare(getName(b)))

    return <Modal
        className={styles['modal']}
        mask={false}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title={<div>
            <p className={styles['title']}>
                <UsersIcon className={styles['users-icon']}/>
                Share this Project
            </p>
            <p className={styles['sub-title']}>Send a copy of your project</p>
        </div>}
    >
        <p className={styles['project-title-label']}>
            Project Title: <span className={styles['project-title']}>{project.title}</span>
        </p>
        <Input
            className={styles['search']}
            placeholder="Search for a colleague name"
            onKeyUp={(e) => setFilterText((e.target as HTMLInputElement).value)}
        />
        <List
            header={<span className={styles['colleagues-title']}>Colleagues List</span>}
            dataSource={displayColleagues}
            loading={colleagues === undefined}
            renderItem={(item: UserDetails) => {
                return <ColleagueListItem key={item.username} projectId={project.id} colleague={item}/>
            }}
        />
    </Modal>
}